import { styled } from '@mui/material/styles';
import { HtmlTooltip } from './HtmlTooltip';

const PREFIX = 'DeleteButton';

export const deleteButtonClasses = {
  autoMarginRight: `${PREFIX}-autoMarginRight`,
  dangerButton: `${PREFIX}-dangerButton`,
  disabledButton: `${PREFIX}-disabledButton`,
};

export const StyledHtmlTooltip = styled(HtmlTooltip)(({ theme }) => ({
  [`& .${deleteButtonClasses.autoMarginRight}`]: {
    marginRight: 'auto',
  },

  [`& .${deleteButtonClasses.dangerButton}`]: {
    color: theme.palette.pink,
  },

  [`& .${deleteButtonClasses.disabledButton}`]: {
    color: theme.palette.grey?.[500],
  },
}));